<div class="modal-header border-0 pb-0">
  <div class="d-flex align-items-center">
    <div class="avatar-lg me-3">
      <span class="avatar-title bg-primary text-white rounded-circle fs-4">
        {{ user ? ((user.userInformation?.firstName?.charAt(0) || '') + (user.userInformation?.lastName?.charAt(0) ||
        '')) : '?' }}
      </span>
    </div>
    <div class="flex-grow-1">
      <h4 class="modal-title mb-1" *ngIf="user">
        {{ user.userInformation?.firstName }} {{ user.userInformation?.lastName }}
      </h4>
      <p class="text-muted mb-0" *ngIf="user">{{ user.email }}</p>
      <!-- Status Badge -->
      <div class="mt-2" *ngIf="user">
        <span class="badge me-2" [class.bg-success]="user.isActive" [class.bg-secondary]="!user.isActive">
          <i class="bi bi-circle-fill me-1"></i>
          {{ user.isActive ? 'ใช้งาน' : 'ไม่ใช้งาน' }}
        </span>
        <span class="badge" [ngClass]="getCPDBadgeClass(getTotalCpdHours())">
          <i class="bi bi-award me-1"></i>
          CPD {{ getTotalCpdHours() }} ชั่วโมง
        </span>
      </div>
    </div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>

<div class="modal-body">
  <!-- User Details -->
  <div *ngIf="user">
    <!-- Tab Navigation -->
    <ul class="nav nav-pills nav-justified mb-4" id="userDetailTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link" [class.active]="activeTab === 'overview'" (click)="setActiveTab('overview')"
          type="button">
          <i class="bi bi-person-circle me-2"></i>ข้อมูลทั่วไป
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" [class.active]="activeTab === 'courses'" (click)="setActiveTab('courses')"
          type="button">
          <i class="bi bi-journal-bookmark me-2"></i>Course การเรียน
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" [class.active]="activeTab === 'licenses'" (click)="setActiveTab('licenses')"
          type="button">
          <i class="bi bi-award me-2"></i>ใบอนุญาต
        </button>
      </li>
    </ul>

    <!-- Tab Content -->
    <!-- Edit Mode Toggle Buttons -->
    <div class="d-flex justify-content-end mb-3" *ngIf="user">
      <button *ngIf="!isEditing" class="btn btn-outline-primary" (click)="toggleEdit()">
        <i class="bi bi-pencil-square me-2"></i>แก้ไขข้อมูล
      </button>
      <div *ngIf="isEditing" class="d-flex gap-2">
        <button class="btn btn-outline-secondary" (click)="cancelEdit()" [disabled]="isSaving">
          <i class="bi bi-x-circle me-2"></i>ยกเลิก
        </button>
        <button class="btn btn-success" (click)="saveChanges()" [disabled]="isSaving">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <i class="bi bi-save me-2" *ngIf="!isSaving"></i>บันทึกข้อมูล
        </button>
      </div>
    </div>

    <div class="tab-content" id="userDetailTabContent">
      <!-- Overview Tab -->
      <div class="tab-pane fade" [class.show]="activeTab === 'overview'" [class.active]="activeTab === 'overview'"
        *ngIf="activeTab === 'overview'">

        <!-- Personal Information -->
        <div class="info-card mb-4">
          <div class="info-card-header">
            <h5><i class="bi bi-person-circle me-2"></i>ข้อมูลส่วนตัว</h5>
          </div>
          <div class="info-card-body">
            <div class="row">
              <div class="col-12 text-center mb-4">
                <!-- Profile Image Display -->
                <div class="position-relative d-inline-block">
                  <img *ngIf="$any(user.userInformation)?.profileImage || user.userInformation?.profilePicture"
                    [src]="$any(user.userInformation)?.profileImage || user.userInformation?.profilePicture"
                    class="rounded-circle profile-preview shadow-sm"
                    style="width: 150px; height: 150px; object-fit: cover; border: 3px solid #dee2e6; background-color: #f8f9fa; cursor: pointer;"
                    alt="Profile Picture"
                    (click)="!isEditing && openImagePreview($any(user.userInformation)?.profileImage || user.userInformation?.profilePicture || '', 'รูปโปรไฟล์')">
                  <div *ngIf="!$any(user.userInformation)?.profileImage && !user.userInformation?.profilePicture"
                    class="rounded-circle profile-preview shadow-sm mx-auto d-flex align-items-center justify-content-center bg-light text-secondary"
                    style="width: 150px; height: 150px; border: 3px dashed #dee2e6;">
                    <i class="bi bi-person-fill" style="font-size: 4rem; opacity: 0.5;"></i>
                  </div>
                  
                  <!-- Edit Mode: Upload/Remove Buttons -->
                  <div *ngIf="isEditing" class="mt-2">
                    <input type="file" id="profileImageInput" accept="image/jpeg,image/jpg,image/png,image/gif"
                      (change)="onProfileImageSelected($event)" style="display: none;">
                    <button type="button" class="btn btn-sm btn-primary me-2" (click)="triggerProfileImageUpload()">
                      <i class="bi bi-upload me-1"></i>อัพโหลดรูปภาพ
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger" 
                      *ngIf="$any(user.userInformation)?.profileImage || user.userInformation?.profilePicture"
                      (click)="removeProfileImage()">
                      <i class="bi bi-trash me-1"></i>ลบรูปภาพ
                    </button>
                    <div class="mt-2">
                      <small class="text-muted">
                        <i class="bi bi-info-circle"></i> รองรับไฟล์ JPG, PNG, GIF (ไม่เกิน 5MB)
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label>ชื่อ-สกุล</label>
                  <div *ngIf="!isEditing">
                    <p>{{ user.userInformation?.firstName }} {{ user.userInformation?.lastName }}</p>
                  </div>
                  <div *ngIf="isEditing" class="d-flex gap-2">
                    <input type="text" class="form-control" [(ngModel)]="user.userInformation!.firstName"
                      placeholder="ชื่อ">
                    <input type="text" class="form-control" [(ngModel)]="user.userInformation!.lastName"
                      placeholder="สกุล">
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label>เลขบัตรประชาชน</label>
                  <p class="font-monospace">{{ user.cid || '-' }}</p>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label>เพศ</label>
                  <div *ngIf="!isEditing">
                    <p>{{ user.userInformation?.gender === 'Male' ? 'ชาย' : user.userInformation?.gender === 'Female' ?
                      'หญิง' : user.userInformation?.gender || '-' }}</p>
                  </div>
                  <div *ngIf="isEditing">
                    <select class="form-select" [(ngModel)]="user.userInformation!.gender">
                      <option value="Male">ชาย</option>
                      <option value="Female">หญิง</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label>วันเกิด</label>
                  <div *ngIf="!isEditing">
                    <p>{{ formatDate(user.userInformation?.dateOfBirth) }}</p>
                  </div>
                  <div *ngIf="isEditing">
                    <input type="text" class="form-control" [(ngModel)]="user.userInformation!.dateOfBirth"
                      placeholder="dd/mm/yyyy"
                      maxlength="10"
                      (input)="onBirthDateInput($event)">
                    <small class="text-muted d-block mt-1">
                      <i class="bi bi-info-circle"></i> รูปแบบ: วว/ดด/ปปปป (พ.ศ.) เช่น 15/05/2543
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label>หมายเลขโทรศัพท์</label>
                  <div *ngIf="!isEditing">
                    <p>{{ formatPhoneNumber(user.userInformation?.phoneNumber) }}</p>
                  </div>
                  <div *ngIf="isEditing">
                    <input type="tel" class="form-control" [(ngModel)]="user.userInformation!.phoneNumber">
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label>อีเมล</label>
                  <div *ngIf="!isEditing">
                    <p>{{ user.email || '-' }}</p>
                  </div>
                  <div *ngIf="isEditing">
                    <input type="email" class="form-control" [(ngModel)]="user.email"
                      placeholder="example@email.com" autocomplete="off">
                    <small class="text-muted d-block mt-1">
                      <i class="bi bi-info-circle"></i> อีเมลใช้สำหรับเข้าสู่ระบบ ต้องไม่ซ้ำกับผู้ใช้อื่น
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <!-- Address Section -->
            <div class="row">
              <div class="col-12">
                <h6 class="mb-3 mt-3">
                  <i class="bi bi-house-door me-2"></i>ที่อยู่
                </h6>

                <!-- Display Mode -->
                <div *ngIf="!isEditing">
                  <!-- Registered Address -->
                  <div class="mb-3">
                    <label class="fw-semibold text-primary">ที่อยู่ตามทะเบียนบ้าน</label>
                    <p class="mb-1">
                      {{ $any(user.userInformation)?.registeredAddress || user.userInformation?.address || '-' }}<br>
                      <span *ngIf="$any(user.userInformation)?.registeredSubdistrict || $any(user.userInformation)?.registeredDistrict || $any(user.userInformation)?.registeredProvince || user.userInformation?.subdistrict || user.userInformation?.district || user.userInformation?.province">
                        ตำบล{{ $any(user.userInformation)?.registeredSubdistrict || user.userInformation?.subdistrict || '-' }}
                        อำเภอ{{ $any(user.userInformation)?.registeredDistrict || user.userInformation?.district || '-' }}
                        จังหวัด{{ $any(user.userInformation)?.registeredProvince || user.userInformation?.province || '-' }}
                        {{ $any(user.userInformation)?.registeredPostalCode || user.userInformation?.postalCode || '' }}
                      </span>
                    </p>
                  </div>

                  <!-- Current Address -->
                  <div class="mb-3">
                    <label class="fw-semibold text-success">ที่อยู่ปัจจุบัน</label>
                    <p class="mb-1">
                      {{ $any(user.userInformation)?.currentAddress || user.userInformation?.address || '-' }}<br>
                      <span *ngIf="$any(user.userInformation)?.currentSubdistrict || $any(user.userInformation)?.currentDistrict || $any(user.userInformation)?.currentProvince || user.userInformation?.subdistrict || user.userInformation?.district || user.userInformation?.province">
                        ตำบล{{ $any(user.userInformation)?.currentSubdistrict || user.userInformation?.subdistrict || '-' }}
                        อำเภอ{{ $any(user.userInformation)?.currentDistrict || user.userInformation?.district || '-' }}
                        จังหวัด{{ $any(user.userInformation)?.currentProvince || user.userInformation?.province || '-' }}
                        {{ $any(user.userInformation)?.currentPostalCode || user.userInformation?.postalCode || '' }}
                      </span>
                    </p>
                  </div>
                </div>

                <!-- Edit Mode -->
                <div *ngIf="isEditing">
                  <!-- Registered Address Card -->
                  <div class="card mb-3 border-primary">
                    <div class="card-header bg-primary bg-opacity-10 border-primary">
                      <h6 class="mb-0 text-primary">
                        <i class="bi bi-house-fill me-2"></i>ที่อยู่ตามทะเบียนบ้าน
                      </h6>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12 mb-3">
                          <label class="form-label">ที่อยู่</label>
                          <input type="text" class="form-control" 
                            [(ngModel)]="$any(user.userInformation).registeredAddress"
                            placeholder="บ้านเลขที่, ซอย, ถนน">
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">จังหวัด</label>
                          <select class="form-select" 
                            [(ngModel)]="$any(user.userInformation).registeredProvince"
                            (change)="onRegisteredProvinceChange($event)">
                            <option value="">-- เลือกจังหวัด --</option>
                            <option *ngFor="let province of provinceList" [value]="province.name_th">
                              {{ province.name_th }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">อำเภอ/เขต</label>
                          <select class="form-select" 
                            [(ngModel)]="$any(user.userInformation).registeredDistrict"
                            [disabled]="registeredDistrictList.length === 0"
                            (change)="onRegisteredDistrictChange($event)">
                            <option value="">-- เลือกอำเภอ/เขต --</option>
                            <option *ngFor="let district of registeredDistrictList" [value]="district.name_th">
                              {{ district.name_th }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">ตำบล/แขวง</label>
                          <select class="form-select" 
                            [(ngModel)]="$any(user.userInformation).registeredSubdistrict"
                            [disabled]="registeredSubdistrictList.length === 0"
                            (change)="onRegisteredSubdistrictChange($event)">
                            <option value="">-- เลือกตำบล/แขวง --</option>
                            <option *ngFor="let subdistrict of registeredSubdistrictList" [value]="subdistrict.name_th">
                              {{ subdistrict.name_th }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">รหัสไปรษณีย์</label>
                          <select class="form-select" 
                            [(ngModel)]="$any(user.userInformation).registeredPostalCode"
                            [disabled]="registeredZipCodeList.length === 0">
                            <option value="">-- เลือกรหัสไปรษณีย์ --</option>
                            <option *ngFor="let zipCode of registeredZipCodeList" [value]="zipCode.code">
                              {{ zipCode.code }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Current Address Card -->
                  <div class="card border-success">
                    <div class="card-header bg-success bg-opacity-10 border-success">
                      <div class="d-flex justify-content-between align-items-center">
                        <h6 class="mb-0 text-success">
                          <i class="bi bi-geo-alt-fill me-2"></i>ที่อยู่ปัจจุบัน
                        </h6>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="sameAsRegistered"
                            [(ngModel)]="sameAsRegistered"
                            (change)="onSameAsRegisteredChange($event)">
                          <label class="form-check-label" for="sameAsRegistered">
                            เหมือนที่อยู่ตามทะเบียนบ้าน
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12 mb-3">
                          <label class="form-label">ที่อยู่</label>
                          <input type="text" class="form-control" 
                            [(ngModel)]="$any(user.userInformation).currentAddress"
                            [disabled]="sameAsRegistered"
                            placeholder="บ้านเลขที่, ซอย, ถนน">
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">จังหวัด</label>
                          <select class="form-select" 
                            [(ngModel)]="$any(user.userInformation).currentProvince"
                            [disabled]="sameAsRegistered"
                            (change)="onCurrentProvinceChange($event)">
                            <option value="">-- เลือกจังหวัด --</option>
                            <option *ngFor="let province of provinceList" [value]="province.name_th">
                              {{ province.name_th }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">อำเภอ/เขต</label>
                          <select class="form-select" 
                            [(ngModel)]="$any(user.userInformation).currentDistrict"
                            [disabled]="sameAsRegistered || currentDistrictList.length === 0"
                            (change)="onCurrentDistrictChange($event)">
                            <option value="">-- เลือกอำเภอ/เขต --</option>
                            <option *ngFor="let district of currentDistrictList" [value]="district.name_th">
                              {{ district.name_th }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">ตำบล/แขวง</label>
                          <select class="form-select" 
                            [(ngModel)]="$any(user.userInformation).currentSubdistrict"
                            [disabled]="sameAsRegistered || currentSubdistrictList.length === 0"
                            (change)="onCurrentSubdistrictChange($event)">
                            <option value="">-- เลือกตำบล/แขวง --</option>
                            <option *ngFor="let subdistrict of currentSubdistrictList" [value]="subdistrict.name_th">
                              {{ subdistrict.name_th }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">รหัสไปรษณีย์</label>
                          <select class="form-select" 
                            [(ngModel)]="$any(user.userInformation).currentPostalCode"
                            [disabled]="sameAsRegistered || currentZipCodeList.length === 0">
                            <option value="">-- เลือกรหัสไปรษณีย์ --</option>
                            <option *ngFor="let zipCode of currentZipCodeList" [value]="zipCode.code">
                              {{ zipCode.code }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Professional Information -->
        <div class="info-card">
          <div class="info-card-header">
            <h5><i class="bi bi-briefcase me-2"></i>ข้อมูลการทำงาน</h5>
          </div>
          <div class="info-card-body">
            <!-- Basic Work Info -->
            <div class="row mb-4">
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label><i class="bi bi-building me-1"></i>ชื่อสถานที่ทำงาน</label>
                  <div *ngIf="!isEditing">
                    <p class="fw-semibold">{{ user.userInformation?.company?.organizationName || '-' }}</p>
                  </div>
                  <div *ngIf="isEditing">
                    <select class="form-select" [(ngModel)]="user.userInformation!.companyId"
                      [disabled]="isLoadingCompanies" (change)="onCompanyChange()">
                      <option value="">-- เลือกองค์กร --</option>
                      <option *ngFor="let company of companyList" [value]="company.id">
                        {{ company.organizationName }}
                      </option>
                    </select>
                    <small class="form-text text-muted" *ngIf="isLoadingCompanies">
                      <i class="bi bi-hourglass-split"></i> กำลังโหลดรายการองค์กร...
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label><i class="bi bi-briefcase me-1"></i>ประเภทธุรกิจ</label>
                  <p>{{ user.userInformation?.company?.organizationType || '-' }}</p>
                </div>
              </div>
              <div class="col-12 mb-3">
                <div class="info-item">
                  <label><i class="bi bi-geo-alt me-1"></i>ที่อยู่สถานที่ทำงาน</label>
                  <p>
                    {{ user.userInformation?.company?.headOfficeAddress || '-' }}
                    <span *ngIf="user.userInformation?.company?.projectName"> {{
                      user.userInformation?.company?.projectName }}</span>
                    <span *ngIf="user.userInformation?.company?.taxSoi"> ซอย{{ user.userInformation?.company?.taxSoi
                      }}</span>
                    <span *ngIf="user.userInformation?.company?.taxRoad"> ถนน{{ user.userInformation?.company?.taxRoad
                      }}</span><br>
                    <span
                      *ngIf="user.userInformation?.company?.taxSubdistrict || user.userInformation?.company?.taxDistrict || user.userInformation?.company?.taxProvince">
                      ตำบล{{ user.userInformation?.company?.taxSubdistrict || '-' }}
                      อำเภอ{{ user.userInformation?.company?.taxDistrict || '-' }}
                      จังหวัด{{ user.userInformation?.company?.taxProvince || '-' }}
                      {{ user.userInformation?.company?.postalCode || '' }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label><i class="bi bi-telephone me-1"></i>เบอร์โทรศัพท์</label>
                  <p>{{ user.userInformation?.company?.officePhone || '-' }}</p>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label><i class="bi bi-device-hdd me-1"></i>มือถือ</label>
                  <p>{{ user.userInformation?.company?.mobilePhone || '-' }}</p>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label><i class="bi bi-envelope me-1"></i>อีเมล</label>
                  <p>{{ user.userInformation?.company?.email || '-' }}</p>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label><i class="bi bi-line me-1"></i>Line ID</label>
                  <p>{{ user.userInformation?.company?.lineId || '-' }}</p>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label><i class="bi bi-globe me-1"></i>เว็บไซต์</label>
                  <p>{{ user.userInformation?.company?.website || '-' }}</p>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="info-item">
                  <label><i class="bi bi-card-text me-1"></i>เลขประจำตัวผู้เสียภาษี</label>
                  <p class="font-monospace">{{ user.userInformation?.company?.taxId || '-' }}</p>
                </div>
              </div>
            </div>

            <!-- Education Info -->
            <div class="professional-section mb-4">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="section-title mb-0">
                  <i class="bi bi-mortarboard-fill me-2"></i>ข้อมูลการศึกษา
                </h6>
                <button *ngIf="isEditing" class="btn btn-sm btn-outline-primary" (click)="addEducationHistory()">
                  <i class="bi bi-plus-circle me-1"></i>เพิ่มประวัติการศึกษา
                </button>
              </div>

              <!-- Education History Table -->
              <div *ngIf="user.userInformation?.educationHistory?.length">
                <div class="table-responsive">
                  <table class="table table-hover table-bordered">
                    <thead class="table-light">
                      <tr>
                        <th width="40%">สถาบันการศึกษา</th>
                        <th width="40%">วุฒิการศึกษาและสาขา</th>
                        <th width="15%">ปีที่จบ</th>
                        <th *ngIf="isEditing" width="5%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let edu of user.userInformation?.educationHistory; let i = index">
                        <td>
                          <span *ngIf="!isEditing">{{ edu.Institution || edu.institution || '-' }}</span>
                          <input *ngIf="isEditing" type="text" class="form-control form-control-sm"
                            [(ngModel)]="edu.institution" placeholder="สถาบันการศึกษา">
                        </td>
                        <td>
                          <span *ngIf="!isEditing">{{ edu['Degree and Major'] || edu.degreeAndMajor || '-' }}</span>
                          <input *ngIf="isEditing" type="text" class="form-control form-control-sm"
                            [(ngModel)]="edu['Degree and Major']" placeholder="วุฒิการศึกษาและสาขา">
                        </td>
                        <td class="text-center">
                          <span *ngIf="!isEditing">{{ edu['Year Complete'] || edu.yearComplete || '-' }}</span>
                          <input *ngIf="isEditing" type="text" class="form-control form-control-sm text-center"
                            [(ngModel)]="edu['Year Complete']" placeholder="ปี พ.ศ.">
                        </td>
                        <td *ngIf="isEditing" class="text-center">
                          <button class="btn btn-sm btn-outline-danger" (click)="removeEducationHistory(i)">
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div *ngIf="!user.userInformation?.educationHistory?.length" class="text-muted text-center py-3">
                <i class="bi bi-inbox"></i> ไม่มีข้อมูลประวัติการศึกษา
              </div>
            </div>

            <!-- Valuation Experience -->
            <div class="professional-section mb-4">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="section-title mb-0">
                  <i class="bi bi-graph-up-arrow me-2"></i>ประสบการณ์การประเมินราคา
                </h6>
                <button *ngIf="isEditing" class="btn btn-sm btn-outline-primary" (click)="addValuationExperience()">
                  <i class="bi bi-plus-circle me-1"></i>เพิ่มประสบการณ์
                </button>
              </div>
              <div *ngIf="user.userInformation?.valuationExperience?.length">
                <div class="table-responsive">
                  <table class="table table-hover table-bordered">
                    <thead class="table-light">
                      <tr>
                        <th width="40%">องค์กร</th>
                        <th width="35%">ตำแหน่ง</th>
                        <th width="20%">ระยะเวลา (ปี)</th>
                        <th *ngIf="isEditing" width="5%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let exp of user.userInformation?.valuationExperience; let i = index">
                        <td>
                          <span *ngIf="!isEditing">{{ exp.organization || '-' }}</span>
                          <input *ngIf="isEditing" type="text" class="form-control form-control-sm"
                            [(ngModel)]="exp.organization">
                        </td>
                        <td>
                          <span *ngIf="!isEditing">{{ exp.position || '-' }}</span>
                          <input *ngIf="isEditing" type="text" class="form-control form-control-sm"
                            [(ngModel)]="exp.position">
                        </td>
                        <td class="text-center">
                          <span *ngIf="!isEditing">{{ exp.years || '-' }}</span>
                          <input *ngIf="isEditing" type="number" class="form-control form-control-sm text-center"
                            [(ngModel)]="exp.years">
                        </td>
                        <td *ngIf="isEditing" class="text-center">
                          <button class="btn btn-sm btn-outline-danger" (click)="removeValuationExperience(i)">
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div *ngIf="!user.userInformation?.valuationExperience?.length" class="text-muted text-center py-3">
                <i class="bi bi-inbox"></i> ไม่มีข้อมูลประสบการณ์การประเมินราคา
              </div>
            </div>

            <!-- Special Courses -->
            <div class="professional-section">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="section-title mb-0">
                  <i class="bi bi-award me-2"></i>หลักสูตรพิเศษ / การอบรม
                </h6>
                <button *ngIf="isEditing" class="btn btn-sm btn-outline-primary" (click)="addSpecialCourse()">
                  <i class="bi bi-plus-circle me-1"></i>เพิ่มหลักสูตร
                </button>
              </div>
              <div *ngIf="user.userInformation?.specialCourses?.length">
                <div class="table-responsive">
                  <table class="table table-hover table-bordered">
                    <thead class="table-light">
                      <tr>
                        <th width="30%">หัวข้อหลักสูตร</th>
                        <th width="20%">หน่วยงาน</th>
                        <th width="15%">CPD (ชม.)</th>
                        <th width="15%">วันที่อบรม (พ.ศ.)</th>
                        <th *ngIf="isEditing" width="5%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let course of user.userInformation?.specialCourses; let i = index">
                        <td>
                          <span *ngIf="!isEditing">{{ course.courseTopic || '-' }}</span>
                          <input *ngIf="isEditing" type="text" class="form-control form-control-sm"
                            [(ngModel)]="course.courseTopic">
                        </td>
                        <td>
                          <span *ngIf="!isEditing">{{ course.organization || '-' }}</span>
                          <input *ngIf="isEditing" type="text" class="form-control form-control-sm"
                            [(ngModel)]="course.organization">
                        </td>
                        <td class="text-center">
                          <span *ngIf="!isEditing" class="badge bg-primary">{{ course.cpdHours || 0 }}</span>
                          <input *ngIf="isEditing" type="number" class="form-control form-control-sm text-center"
                            [(ngModel)]="course.cpdHours">
                        </td>
                        <td class="text-center">
                          <span *ngIf="!isEditing">{{ course.trainingDate || '-' }}</span>
                          <input *ngIf="isEditing" type="text" class="form-control form-control-sm"
                            [(ngModel)]="course.trainingDate"
                            placeholder="dd/mm/yyyy"
                            maxlength="10"
                            (input)="onTrainingDateInput($event, i)">
                        </td>
                        <td *ngIf="isEditing" class="text-center">
                          <button class="btn btn-sm btn-outline-danger" (click)="removeSpecialCourse(i)">
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div *ngIf="!user.userInformation?.specialCourses?.length" class="text-muted text-center py-3">
                <i class="bi bi-inbox"></i> ไม่มีข้อมูลหลักสูตรพิเศษ
              </div>
            </div>

            <!-- Additional Notes -->
            <div class="professional-section mt-4" *ngIf="user.userInformation?.notes">
              <h6 class="section-title">
                <i class="bi bi-sticky me-2"></i>หมายเหตุเพิ่มเติม
              </h6>
              <div class="alert alert-info mb-0">
                <i class="bi bi-info-circle me-2"></i>{{ user.userInformation?.notes }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Courses Tab -->
      <div class="tab-pane fade" [class.show]="activeTab === 'courses'" [class.active]="activeTab === 'courses'"
        *ngIf="activeTab === 'courses'">

        <!-- Course History -->
        <div class="course-history">
          <h5 class="mb-3">
            <i class="bi bi-clock-history me-2"></i>ประวัติการเรียน Course
          </h5>

          <!-- Loading State -->
          <div *ngIf="isLoadingCpdHours" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="text-muted mt-3">กำลังโหลดข้อมูล CPD Hours...</p>
          </div>

          <!-- Error State -->
          <div *ngIf="cpdHoursError && !isLoadingCpdHours" class="alert alert-danger" role="alert">
            <i class="bi bi-exclamation-triangle me-2"></i>{{ cpdHoursError }}
          </div>

          <!-- Empty State -->
          <div *ngIf="!isLoadingCpdHours && !cpdHoursError && cpdHoursList.length === 0" class="text-center py-5">
            <i class="bi bi-inbox" style="font-size: 3rem; color: #dee2e6;"></i>
            <p class="text-muted mt-3">ยังไม่มีประวัติการเรียน Course</p>
          </div>

          <!-- Course Timeline -->
          <div class="course-timeline" *ngIf="!isLoadingCpdHours && !cpdHoursError && cpdHoursList.length > 0">
            <!-- Course Item from API -->
            <div class="course-card mb-4" *ngFor="let cpd of cpdHoursList"
              [class.approved-card]="cpd.isVerified && cpd.isCompleted">
              <div class="card shadow-sm border-0">
                <div class="card-body">
                  <!-- Course Header with Status -->
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="flex-grow-1">
                      <h6 class="course-title mb-2">
                        <i class="bi bi-journal-bookmark-fill text-primary me-2"></i>
                        {{ cpd.sessionTitle }}
                      </h6>
                      <p class="course-description text-muted mb-0" *ngIf="cpd.notes || cpd.course.description">
                        <small>{{ cpd.notes || cpd.course.description }}</small>
                      </p>
                    </div>

                    <!-- Approved Status Badge -->
                    <div *ngIf="cpd.isVerified && cpd.isCompleted" class="ms-3">
                      <span class="badge bg-success rounded-pill px-3 py-2">
                        <i class="bi bi-check-circle-fill me-1"></i>
                        <strong>อนุมัติแล้ว</strong>
                      </span>
                    </div>
                  </div>

                  <!-- View Evidence Button -->
                  <div class="view-evidence-section mb-3" *ngIf="cpd.imageThumbnail">
                    <button type="button" class="btn btn-outline-primary btn-sm" 
                      (click)="openImagePreview(cpd.imageThumbnail, cpd.sessionTitle)">
                      <i class="bi bi-file-earmark-image me-1"></i>ดูหลักฐาน
                    </button>
                  </div>

                  <!-- Course Details Badges -->
                  <div class="course-details mb-3 d-flex flex-wrap gap-2">
                    <span class="badge bg-primary rounded-pill">
                      <i class="bi bi-clock me-1"></i>{{ cpd.hoursStudied }} ชั่วโมง
                    </span>
                    <span class="badge rounded-pill" [class.bg-success]="cpd.cpdCourseStatus.name === 'Approved'"
                      [class.bg-warning]="cpd.cpdCourseStatus.name === 'รอ Approve'"
                      [class.bg-danger]="cpd.cpdCourseStatus.name === 'ไม่ผ่าน'">
                      <i class="bi bi-check-circle me-1"></i>{{ cpd.cpdCourseStatus.name }}
                    </span>
                    <span class="badge rounded-pill" [class.bg-success]="cpd.cpdPaymentStatus.name === 'ชำระเงินแล้ว'"
                      [class.bg-warning]="cpd.cpdPaymentStatus.name === 'รอชำระเงิน'"
                      [class.bg-info]="cpd.cpdPaymentStatus.name === 'ฟรี'">
                      <i class="bi bi-credit-card me-1"></i>{{ cpd.cpdPaymentStatus.name }}
                    </span>
                    <span class="badge bg-info rounded-pill" *ngIf="cpd.certificationBySEC">
                      <i class="bi bi-award me-1"></i>รับรองโดย กลต.
                    </span>
                  </div>

                  <!-- Course Meta Information -->
                  <div class="course-meta text-muted mb-3">
                    <small>
                      <i class="bi bi-calendar3 me-1"></i>วันที่เรียน: {{ formatDate(cpd.studyDate) }}
                      <span class="ms-3" *ngIf="cpd.course.instructor">
                        <i class="bi bi-person-badge me-1"></i>{{ cpd.course.instructor }}
                      </span>
                    </small>
                  </div>

                  <!-- Payment Slip Preview -->
                  <div class="payment-slip-preview mb-3" *ngIf="cpd.paymentSlip">
                    <div class="alert alert-info mb-0 py-2 px-3">
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                          <i class="bi bi-receipt me-2"></i>
                          <span class="fw-semibold">สลิปการชำระเงิน</span>
                          <span class="badge bg-primary ms-2" *ngIf="cpd.amount">{{ cpd.amount }} บาท</span>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-primary" 
                          (click)="openImagePreview(cpd.paymentSlip, 'สลิปการชำระเงิน - ' + cpd.sessionTitle)">
                          <i class="bi bi-eye me-1"></i>ดูสลิป
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Full Image Preview (if different from thumbnail) -->
                  <div class="full-image-preview mb-3" *ngIf="cpd.image && cpd.image !== cpd.imageThumbnail">
                    <button type="button" class="btn btn-sm btn-outline-secondary w-100" 
                      (click)="openImagePreview(cpd.image, 'รูปภาพเต็ม - ' + cpd.sessionTitle)">
                      <i class="bi bi-image me-1"></i>ดูรูปภาพความละเอียดสูง
                    </button>
                  </div>

                  <!-- Action Buttons -->
                  <div class="d-flex gap-2 align-items-center flex-wrap">
                    <!-- Approve Button (Grey/Secondary) -->
                    <button type="button" class="btn btn-secondary btn-sm"
                      *ngIf="!cpd.isVerified || !cpd.isCompleted"
                      [disabled]="!canApproveCourse(cpd)"
                      (click)="approveCourse(cpd)">
                      <i class="bi bi-check-circle me-1"></i>Approve Course เรียน
                    </button>

                    <!-- Cannot approve here (course date is July 2568 or later) -->
                    <div *ngIf="(!cpd.isVerified || !cpd.isCompleted) && !canApproveCourse(cpd)"
                      class="alert alert-warning mb-0 py-2 px-3 d-flex align-items-center">
                      <i class="bi bi-exclamation-triangle-fill me-2"></i>
                      <span>ไม่สามารถอนุมัติในหน้านี้ได้ (วันที่เรียนตั้งแต่เดือนกรกฎาคม 2569 เป็นต้นไป)</span>
                    </div>

                    <!-- Already Approved Message -->
                    <div *ngIf="cpd.isVerified && cpd.isCompleted"
                      class="alert alert-success mb-0 py-2 px-3 d-flex align-items-center">
                      <i class="bi bi-check-circle-fill me-2"></i>
                      <span><strong>คอร์สนี้ได้รับการอนุมัติเรียบร้อยแล้ว</strong></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Licenses Tab -->
      <div class="tab-pane fade" [class.show]="activeTab === 'licenses'" [class.active]="activeTab === 'licenses'"
        *ngIf="activeTab === 'licenses'">

        <!-- Member Card Information Section -->
        <div class="row mb-4">
          <div class="col-12">
            <div class="card border-0 shadow-sm">
              <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center py-3">
                <h5 class="mb-0">
                  <i class="bi bi-credit-card-2-front text-primary me-2"></i>
                  ข้อมูลบัตรสมาชิก
                </h5>
                <span class="badge bg-success rounded-pill px-3 py-2" *ngIf="user?.userInformation?.userStatusId === 1">
                  <i class="bi bi-check-circle-fill me-1"></i>
                  <strong>APPROVED</strong>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- VAT License -->
          <div class="col-md-6 mb-4">
            <div class="license-card">
              <div class="license-header bg-primary">
                <div class="license-icon">
                  <i class="bi bi-shield-check"></i>
                </div>
                <div class="license-title">
                  <h5>ใบอนุญาต VAT</h5>
                  <p>Value Added Tax License</p>
                </div>
              </div>
              <div class="license-body">
                <div class="license-info">
                  <label>ประเภทสมาชิก VAT</label>
                  <div *ngIf="!isEditing">
                    <p class="license-id">{{ user.userInformation?.vatType || '-' }}</p>
                  </div>
                  <div *ngIf="isEditing">
                    <select class="form-select" [(ngModel)]="user.userInformation!.vatType">
                      <option value="ยังไม่มีบัตรสมาชิก">ยังไม่มีบัตรสมาชิก</option>
                      <option value="วิสามัญ">วิสามัญ</option>
                      <option value="สามัญ">สามัญ</option>
                      <option value="ตลอดชีพ">ตลอดชีพ</option>
                    </select>
                  </div>
                </div>
                <div class="license-info">
                  <label>หมายเลข VAT ID</label>
                  <div *ngIf="!isEditing">
                    <p class="license-id">{{ user.userInformation?.vatId || '-' }}</p>
                  </div>
                  <div *ngIf="isEditing">
                    <input type="text" class="form-control" [(ngModel)]="user.userInformation!.vatId"
                      placeholder="กรอกหมายเลข VAT ID" style="font-family: 'Courier New', monospace;">
                  </div>
                </div>
                <div class="license-info">
                  <label>วันหมดอายุ</label>
                  <div *ngIf="!isEditing">
                    <p class="license-expiry">
                      <span class="badge" [ngClass]="getStatusBadgeClass(getVATExpirationStatus())">
                        <i class="bi bi-calendar me-1"></i>
                        {{ getVATExpiryText() }}
                      </span>
                    </p>
                  </div>
                  <div *ngIf="isEditing">
                    <input type="text" class="form-control" [(ngModel)]="user.userInformation!.vatExpired"
                      placeholder="dd/mm/yyyy"
                      maxlength="10"
                      (input)="onVATExpiryDateInput($event)">
                    <small class="text-muted d-block mt-1">
                      <i class="bi bi-info-circle"></i> รูปแบบ: วว/ดด/ปปปป (พ.ศ.) เช่น 15/05/2543
                    </small>
                  </div>
                </div>
                <div class="license-status">
                  <span class="status-indicator" [ngClass]="getVATExpirationStatus()"></span>
                  {{ getExpirationText(getVATExpirationStatus()) }}
                </div>
              </div>
            </div>
          </div>

          <!-- Valuer License -->
          <div class="col-md-6 mb-4">
            <div class="license-card">
              <div class="license-header bg-success">
                <div class="license-icon">
                  <i class="bi bi-patch-check"></i>
                </div>
                <div class="license-title">
                  <h5>ใบอนุญาต Valuer</h5>
                  <p>Professional Valuer License</p>
                </div>
              </div>
              <div class="license-body">
                <div class="license-info">
                  <label>ผู้ประเมินหลักประเภท (Valuer Rank)</label>
                  <div *ngIf="!isEditing">
                    <p class="license-id">{{ user.userInformation?.valuerType || '-' }}</p>
                  </div>
                  <div *ngIf="isEditing">
                    <select class="form-select" [(ngModel)]="user.userInformation!.valuerType">
                      <option value="ไม่มี">ไม่มี</option>
                      <option value="วิสามัญ">วิสามัญ</option>
                      <option value="สามัญ">สามัญ</option>
                      <option value="วุฒิ">วุฒิ</option>
                    </select>
                  </div>
                </div>
                <div class="license-info">
                  <label>หมายเลข Valuer ID</label>
                  <div *ngIf="!isEditing">
                    <p class="license-id">{{ user.userInformation?.valuerId || '-' }}</p>
                  </div>
                  <div *ngIf="isEditing">
                    <input type="text" class="form-control" [(ngModel)]="user.userInformation!.valuerId"
                      placeholder="กรอกหมายเลข Valuer ID" style="font-family: 'Courier New', monospace;">
                  </div>
                </div>
                <div class="license-info">
                  <label>วันหมดอายุ</label>
                  <div *ngIf="!isEditing">
                    <p class="license-expiry">
                      <span class="badge" [ngClass]="getStatusBadgeClass(getValuerExpirationStatus())">
                        <i class="bi bi-calendar me-1"></i>
                        {{ formatDate(user.userInformation?.valuerExpired) }}
                      </span>
                    </p>
                  </div>
                  <div *ngIf="isEditing">
                    <input type="text" class="form-control" [(ngModel)]="user.userInformation!.valuerExpired"
                      placeholder="dd/mm/yyyy"
                      maxlength="10"
                      (input)="onValuerExpiryDateInput($event)">
                    <small class="text-muted d-block mt-1">
                      <i class="bi bi-info-circle"></i> รูปแบบ: วว/ดด/ปปปป (พ.ศ.) เช่น 15/05/2543
                    </small>
                  </div>
                </div>
                <div class="license-status">
                  <span class="status-indicator" [ngClass]="getValuerExpirationStatus()"></span>
                  {{ getExpirationText(getValuerExpirationStatus()) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer border-0 pt-3">
  <button type="button" class="btn btn-secondary" (click)="close()">
    <i class="bi bi-x-circle me-2"></i>ปิด
  </button>
  <div class="ms-auto">
    <button type="button" class="btn btn-danger me-2" (click)="rejectUser()"
      *ngIf="user?.userInformation?.userStatusId !== 3">
      <i class="bi bi-x-circle me-2"></i>ไม่ผ่านการ Approve
    </button>
    <button type="button" class="btn btn-success" (click)="approveUser()"
      *ngIf="user?.userInformation?.userStatusId !== 1">
      <i class="bi bi-check-circle me-2"></i>Approved
    </button>
  </div>
</div>